/**
 * GamesSection - Games Grid Section
 *
 * Displays games derived from the hub's assigned competitions.
 * Games are fetched from the Competition system based on competition IDs.
 */

import { FaGamepad, FaExternalLinkAlt } from "react-icons/fa";
import "./GamesSection.scss";

interface GamesSectionProps {
    competitionId?: string;
}

/**
 * Placeholder component — shows that a competition is assigned.
 * Will be expanded to fetch actual game cards from the competition umbrella.
 */
export const GamesSection = ({ competitionId }: GamesSectionProps) => {
    if (!competitionId) {
        return (
            <section className="section games-section">
                <div className="section__empty">
                    <FaGamepad size={48} />
                    <h3>No Games Available</h3>
                    <p>Check back soon for featured games.</p>
                </div>
            </section>
        );
    }

    return (
        <section className="section games-section">
            <div className="section__header">
                <h2>
                    <FaGamepad />
                    Featured Games
                </h2>
                <p>Explore games and complete challenges to earn rewards</p>
            </div>

            <div className="games-section__grid">
                <div className="games-section__card">
                    <div className="games-section__card-image">
                        <div className="games-section__card-placeholder">
                            <FaGamepad size={32} />
                        </div>
                    </div>
                    <div className="games-section__card-content">
                        <h3>Competition Active</h3>
                        <p className="games-section__card-subtitle">
                            Games are loaded from the assigned competition
                        </p>
                        <button
                            className="games-section__card-action"
                            disabled
                            title="Coming soon"
                        >
                            View Competitions
                            <FaExternalLinkAlt size={12} />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};
